import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  Tooltip,
  Box,
  makeStyles,
} from '@material-ui/core'

import { ReactComponent as Automatic } from '../../../assets/img/icons/ico-automatico.svg'

const useStyles = makeStyles(() => ({
  tooltip: {
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
    borderRadius: '8px',
    padding: '8px 16px',
    maxWidth: '250px',
    minHeight: '26px',
  },
  arrow: {
    color: '#FFFFFF',
    '&::before': {
      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
    },
  },
  tooltipContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 0,
    '& svg': {
      display: 'block',
      width: 15,
      height: 15,
    },
  },
  text: {
    fontFamily: 'SF Pro, sans-serif',
    fontSize: '11px',
    lineHeight: '13px',
    letterSpacing: '0.06px',
    color: '#333333',
    fontWeight: 400,
    whiteSpace: 'nowrap',
  },
  iconWrapper: {
    display: 'inline-flex',
    cursor: 'pointer',
    alignItems: 'center',
  },
}))

const AutomaticTooltip = ({ children, text }) => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)

  const handleTooltipOpen = () => {
    setOpen(true)
  }

  const handleTooltipClose = () => {
    setOpen(false)
  }

  const tooltipContent = (
    <Box className={classes.tooltipContent}>
      <Box className={classes.iconContainer}>
        <Automatic />
      </Box>
      <span className={classes.text}>
        {text}
      </span>
    </Box>
  )

  return (
    <Tooltip
      title={tooltipContent}
      open={open}
      onClose={handleTooltipClose}
      onOpen={handleTooltipOpen}
      placement="top"
      arrow
      classes={{
        tooltip: classes.tooltip,
        arrow: classes.arrow,
      }}
      interactive
      enterDelay={200}
      leaveDelay={200}
    >
      <span
        onMouseEnter={handleTooltipOpen}
        onMouseLeave={handleTooltipClose}
        className={classes.iconWrapper}
      >
        {children}
      </span>
    </Tooltip>
  )
}

AutomaticTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  text: PropTypes.string,
}

AutomaticTooltip.defaultProps = {
  text: 'Passível de Emissão Automática',
}

export default AutomaticTooltip
